import { CountriesType } from '../components/language-selector/CountriesType';
import { UserTypes } from '../../auth/enums/UserTypes';
import { DocumentTypes } from '../../forms/components/tax-id/DocumentTypes';
import { ListDNIForCountry } from './ListDNIForCountry';

export const BuildMaskDocuments: {
	[key in CountriesType]: (userType: UserTypes) => string;
} = {
	[CountriesType.BR]: (userType: UserTypes) => {
		switch (userType) {
			case UserTypes.PF:
				return '999.999.999-99';
			case UserTypes.PJ:
				return '99.999.999/9999-99';
		}
	},
	[CountriesType.MX]: () => {
		return '999999999999999999';
	},
	[CountriesType.CO]: () => {
		return '999999999999999999';
	},
};

export const BuildDocumentType: {
	[key in CountriesType]: (userType: UserTypes) => string;
} = {
	[CountriesType.BR]: (userType: UserTypes) => {
		switch (userType) {
			case UserTypes.PF: {
				const type = DocumentTypes.BR.find(
					document => document.code === ListDNIForCountry.BR.CPF
				);
				return type?.code;
			}
			case UserTypes.PJ: {
				const type = DocumentTypes.BR.find(
					document => document.code === ListDNIForCountry.BR.CNPJ
				);
				return type?.code;
			}
		}
	},
	[CountriesType.MX]: (userType: UserTypes) => {
		switch (userType) {
			case UserTypes.PF: {
				const type = DocumentTypes.BR.find(
					document => document.code === ListDNIForCountry.MX.RFC
				);
				return type?.code;
			}
			case UserTypes.PJ: {
				const type = DocumentTypes.BR.find(
					document => document.code === ListDNIForCountry.MX.CURP
				);
				return type?.code;
			}
		}
	},
	[CountriesType.CO]: (userType: UserTypes) => {
		switch (userType) {
			case UserTypes.PF: {
				const type = DocumentTypes.BR.find(
					document => document.code === ListDNIForCountry.CO.CC
				);
				return type?.code;
			}
			case UserTypes.PJ: {
				const type = DocumentTypes.BR.find(
					document => document.code === ListDNIForCountry.CO.RUT
				);
				return type?.code;
			}
		}
	},
};
